'use client';

import React from 'react';
import { motion } from 'framer-motion';
import ProjectCard from '../common/ProjectCard';

type ListViewProps = {
  relatedProjects: any;
};

export default function RelatedProjects({ relatedProjects }: ListViewProps) {
  if (!relatedProjects || relatedProjects.length === 0) {
    return null; // ⬅️ This handles undefined and empty array
  }

  return (
    <section className="ps-4 md:ps-0 pb-[80px] pt-20 lg:pt-[6.75rem] lg:py-[108px] related-project">
      <h2 className="text-[22px] font-light mb-4 md:mb-7 md:text-center leading-none">Related</h2>
      <div className="flex md:grid md:grid-cols-4 gap-3 flex-nowrap overflow-x-auto md:overflow-x-visible whitespace-nowrap">
        {relatedProjects.map((project: any, index: number) => {
          const desktopImage = project.media?.desktop_media?.[0]?.url || '/default-desktop.jpg';
          const mobileImage = project.media?.mobile_media?.[0]?.url || '/default-mobile.jpg';

          return (
            <motion.div
              key={project.id || index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="min-w-80 md:min-w-min block-cls"
            >
              <ProjectCard
                desktopImageSrc={desktopImage}
                mobileImageSrc={mobileImage}
                title={project.name}
                baseLink={`/projects/${project.slug}`}
                enableMuxVideo={project?.media?.enable_mux_video}
                muxPlaybackId={project?.media?.mux_video?.playback_id}
              />
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
